/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21lbWJlcnMvZGV0YWlscy1wYWdlL21lbWJlcnMtYXRobGV0ZXMvYm9vdHN0cmFwLW1lbWJlcnMtYXRobGV0ZXMtZmlsdGVycy9ib290c3RyYXAtbWVtYmVycy1hdGhsZXRlcy1maWx0ZXJzLmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
